import * as React from 'react';
import { ButtonProps, Button } from '../Button/Button';
import { ConfirmModalProps, ConfirmModal } from '../Modal';

export type ConfirmButtonProps = Omit<ButtonProps, 'onClick'> &
    Pick<ConfirmModalProps, 'cancelText' | 'confirmationText' | 'confirmText' | 'message'> & {
        /**
         * Action handler for confirm button in the modal
         */
        onConfirm: () => void;
        /**
         * The title of the modal
         *
         * @default 'Are you sure?'
         */
        title?: string;
    };

const ConfirmButton: React.FunctionComponent<ConfirmButtonProps> = ({
    cancelText,
    confirmationText,
    confirmText,
    disabled,
    label,
    message,
    onConfirm,
    theme = 'default',
    title = 'Are you sure?',
    ...remainingProps
}) => {
    const [isShowingModal, showModal] = React.useState(false);

    return (
        <>
            <Button
                disabled={disabled}
                label={label}
                theme={theme}
                onClick={() => showModal(true)}
                {...remainingProps}
            />
            <ConfirmModal
                cancelText={cancelText}
                confirmText={confirmText}
                confirmTheme={theme}
                confirmationText={confirmationText}
                message={message}
                show={isShowingModal}
                title={title}
                onClose={() => showModal(false)}
                onConfirm={onConfirm}
            />
        </>
    );
};

ConfirmButton.displayName = 'ConfirmButton';

export default ConfirmButton;
